import { render } from "./Performance_SE.vue?vue&type=template&id=2fea0f62&scoped=true"
import script from "./Performance_SE.vue?vue&type=script&lang=js"
export * from "./Performance_SE.vue?vue&type=script&lang=js"

import "./Performance_SE.vue?vue&type=style&index=0&id=2fea0f62&scoped=true&lang=css"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fea0f62"]])

export default __exports__